class Monitoring.Methods.NotificationEventsHandler

  constructor: (@notificationsView) ->

  handleEvent: (event) =>
    newRelicLogger.logSseEvent(event)
    return if event.account_id != Keepcon.currentAccount.id

    switch event.event_type
      when "ProcessExecutionFinished" then @updateCount(event)
      else return

  updateCount: (event) =>
    @notificationsView.updateCount(event.total_of_not_read_processes)
